import { render, staticRenderFns } from "./cambioEmail.vue?vue&type=template&id=61e8dbc6&"
import script from "./cambioEmail.vue?vue&type=script&lang=js&"
export * from "./cambioEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports